import React, { useState } from 'react';
import './schedule.css';
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { collection, addDoc } from 'firebase/firestore';
import Navbar from '../../Components/Navbar/Navbar';
require('dotenv').config();

const firebaseApp = initializeApp({
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APPID,
});

export const db = getFirestore();

const Schedule = () => {
  const [testName, setTestName] = useState('');
  const [testUrl, setTestUrl] = useState('');

  const addTest = async (e) => {
    e.preventDefault();

    if (testName && testUrl) {
      try {
        const docRef = await addDoc(collection(db, 'Tests'), {
          Name: testName,
          Url: testUrl,
        });
        console.log('Document written with ID: ', docRef.id);
      } catch (e) {
        console.error('Error adding document: ', e);
      }
    }

    setTestName('');
    setTestUrl('');
  };

  return (
    <>
      <form className='form' onSubmit={addTest}>
        <Navbar />
        <div className='flex_form'>
          <h1> Schedule a Test! 📚</h1>
          <div className='form-control'>
            <label htmlFor='firstName'>Name of the Test : &nbsp;</label>
            <input
              type='text'
              id='firstName'
              name='firstName'
              value={testName}
              onChange={(e) => setTestName(e.target.value)}
            />
          </div>
          <div className='form-control'>
            <label htmlFor='email'>Paste Url of Test : &nbsp;</label>
            <input
              type='url'
              id='email'
              name='email'
              value={testUrl}
              onChange={(e) => setTestUrl(e.target.value)}
            />
          </div>
          <button className='sec-btn' type='submit'>
            Submit
          </button>
        </div>
      </form>
    </>
  );
};

export default Schedule;
